<template>
  <div class="flex justify-center my-1">
  <!-- Toggle Button -->
  <label :for="id" class="flex justify-center items-center cursor-pointer">
    <!-- toggle -->
    <div class="relative">
      <!-- input -->
      <input :id="id" type="checkbox" class="hidden" v-model='toggleValue' />
      <!-- line -->
      <div class="toggle__line w-10 h-4 bg-gray-500 rounded-full shadow-inner"></div>
      <!-- dot -->
      <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0">
        <slot v-if='toggleValue' name="on" />
        <slot v-else name="off" />
      </div>
    </div>
    <!-- label -->
    <div v-if='label' class="ml-3 text-gray-700 font-medium">{{label}}</div>
  </label>
</div>

</template>
<script>
import uuid from 'uuid'
export default {
  props:{
    value:{
      type:Boolean,
      required:true
    },
    label:{
      type:String,
      default:''
    }
  },
  components:{
  },
  data() {
    const id = uuid.v4();
    return {
      toggleValue:this.value,
      id:'toggle_' + id
    }
  },
  watch:{
    value(nv, ov) {
      console.log('V', nv, ov);
      if (nv !== this.toggleValue) {
        this.toggleValue = nv;
      }
    },
    toggleValue(nv, ov) {
      console.log('TV', nv, ov);
      if (nv !== ov && nv !== this.value) {
        this.$emit("toggle");
        this.$emit("input", this.toggleValue);
        this.$emit("change", nv, ov);
      }
    }
  }
}
</script>
<style>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>
